var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { format } from "date-fns";
import { cloneDeep } from "lodash";
import { BaseService, prepareParams, } from "./baseService";
class VehicleService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "vehicle/foreman";
    }
    getCurrentVehicle(foremanId, jobId, date) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`${this.controllerName}/${foremanId}/job/${jobId}/current?date=${format(date, "yyyy-MM-dd")}`);
            return data;
        });
    }
    getVehicles(foremanId, jobId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            if (options && options.endDate && options.startDate) {
                const startDate = options.startDate;
                const endDate = options.endDate;
                const updatedOptions = cloneDeep(options);
                updatedOptions.startDate = undefined;
                updatedOptions.endDate = undefined;
                const params = prepareParams(updatedOptions);
                params.startDate = startDate.toISOString();
                params.endDate = endDate.toISOString();
                const { data } = yield this.api.get(`${this.controllerName}/${foremanId}/job/${jobId}`, { params });
                return data;
            }
            const params = prepareParams(options);
            const { data } = yield this.api.get(`${this.controllerName}/${foremanId}/job/${jobId}`, { params });
            return data;
        });
    }
}
export const vehicleService = new VehicleService();
//# sourceMappingURL=vehicleService.js.map